import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { useGet } from "../../customHooks/useGet";
import { useAuthProvider } from "../../customHooks/authContext";
import { Container, Table, Alert, Button } from "react-bootstrap";
import { FaPlus, FaArrowLeft, FaArrowRight, FaEdit, FaTrash, FaPaperPlane, FaSchool } from "react-icons/fa"; 
import PerformanceEdit from "./PerformanceEditAdmin";
import "bootstrap/dist/css/bootstrap.min.css";
import ConfirmModal from "../performance/ConfirmModal";
import PerformanceForm from "../EventOrganization/PerformanceFormAdm";
import { del, put } from "../../services/Services";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FloatingButton = ({ onClick, icon, title, position }) => (
  <button
    className="btn position-fixed rounded-circle p-3 shadow-lg d-flex align-items-center justify-content-center"
    onClick={onClick}
    aria-label={title}
    title={title}
    style={{
      background: "linear-gradient(135deg, #007bff, #6610f2)",
      color: "white",
      fontSize: "1.5rem",
      border: "none",
      width: "60px",
      height: "60px",
      transition: "transform 0.2s ease, box-shadow 0.3s ease",
      zIndex: 1050,
      bottom: "20px",
      right: position === "add" ? "20px" : "90px",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "scale(1.1)";
      e.currentTarget.style.boxShadow = "0px 0px 15px rgba(102, 16, 242, 0.6)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "scale(1)";
      e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
    }}
  >
    {icon}
  </button>
);


const ManagementPerformances = () => {
  const location = useLocation();
  const { registrationId, eventId, schoolId, school } = location.state || {};
  console.log(`Escuela: ${school}`);
  const { token } = useAuthProvider();
  const [page, setPage] = useState(0);
  const size = 8;
  const [formMode, setFormMode] = useState(null);
  const [selectedPerformance, setSelectedPerformance] = useState(null);
  const [showHelpMessage, setShowHelpMessage] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
 
  const { data: performancesData, refetch } = useGet(
    registrationId
      ? `https://ectech-software.com.ar/api/academy/events/registration/${registrationId}/performance?page=${page}&size=${size}`
      : null,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  const totalPages = performancesData?.totalPages || 1;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPerformanceId, setSelectedPerformanceId] = useState(null);

  const handleEditPerformance = (performance, registrationId, eventId, schoolId) => {
    setFormMode('edit');
    setSelectedPerformance(performance);
  };

  const handleNewPerformance = (registrationId, eventId, schoolId) => {
   setFormMode('create');
   };

  const handleFormClose = (reload = false) => {
    setFormMode(null);
    setShowForm(false);
    setShowEditForm(false);
    setSelectedPerformance(null);
    
    if (reload) refetch();
  };

   const handleScholarShipPerformance = async (performance, registrationId) => {
    const performanceId = performance.id;
    const isCurrentlyScholarshipped = performance.isScholarship;

    

  
    try {
      const url = `https://ectech-software.com.ar/api/academy/events/registration/${registrationId}/performance/${performanceId}/scholarship`;
      await put(
        url,
        { isScholarship: !isCurrentlyScholarshipped },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      alert(
        !isCurrentlyScholarshipped
          ? "La obra fue becada exitosamente."
          : "La beca fue retirada exitosamente."
      );
  
      refetch();
    } catch (error) {
      console.error("Error al cambiar el estado de beca:", error);
      alert("Ocurrió un error al actualizar el estado de beca.");
    }
  };
  
  

  const handleHelpMessageClose = () => {
    setShowHelpMessage(false);
  };

  const handleDeletePerformance = async (id) => {
    try {
      const response = await del(
        `/api/academy/events/registration/${registrationId}/performance/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      if (response.status === 200) {
        refetch();
        setSelectedPerformanceId(null); // Cerrar el modal después de eliminar
      } else {
        alert("No se pudo eliminar la obra.");
      }
    } catch (error) {
      console.error("Error al eliminar:", error);
      alert("Hubo un problema al eliminar la obra.");
    }
  };

  

  return (
    <Container className="container mt-4 pb-5">
      <h1 className="text-center">Obras de {school}</h1>
       {performancesData?.content?.length === 0 ? (
        <Alert variant="info" className="text-center">
          No hay Obras disponibles.
        </Alert>
      ) : (
        <>
          <Table striped bordered hover className="text-center">
            <thead className="table-primary">
              <tr>
                <th>Orden</th>
                <th>Nombre</th>
                <th>Categoría</th>
                <th>Modalidad</th>
                <th>Forma</th>
                <th>Preparador /a</th>
                <th>Es Coregrafía?</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {performancesData?.content
                .slice() // Clonamos el array para no mutar el original
                .sort((a, b) => a.order - b.order) // Orden ascendente por order
                .map((performance, index) => (
                  <tr key={`${performance.id}-${index}`}>
                    <td className="fw-bold">{performance.order}</td>
                    <td>{performance.name}</td>
                    <td>{performance.category?.name || "N/A"}</td>
                    <td>{performance.modality?.name || "N/A"}</td>
                    <td>{performance.form?.name || "N/A"}</td>
                    <td>
                        {
                          performance.participants
                            ?.filter(p => p.type?.name === "Preparador")
                            .map(p => `${p.member?.name} ${p.member?.surname}`)
                            .join(", ") || ""
                        }
                    </td>
                    <td>
                    {performance.isChoreographed === true ? "SI" : ""}
                  </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm me-2"
                        onClick={() => handleEditPerformance(performance, registrationId, eventId, schoolId)}
                      >
                        <FaEdit /> 
                      </button>
                      <button
                className="btn btn-danger btn-sm me-2"
                onClick={() => setSelectedPerformanceId(performance.id)}
              >
                <FaTrash /> 
              </button>

              <ConfirmModal
                isOpen={selectedPerformanceId === performance.id}
                onClose={() => setSelectedPerformanceId(null)}
                onConfirm={() => handleDeletePerformance(selectedPerformanceId)}
              />
                     
                      <button
                        className={`btn btn-sm me-2 ${
                          performance.isScholarship ? "btn-danger" : "btn-primary"
                        }`}
                        onClick={() => handleScholarShipPerformance(performance, registrationId)}
                      >
                        <FaSchool /> {performance.isScholarship ? "Desbecar" : "Becar"}
                      </button>

                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>

          {/* 📌 Controles de paginación */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <Button variant="secondary" onClick={() => setPage(page - 1)} disabled={page === 0}>
              <FaArrowLeft /> Anterior
            </Button>
            <span className="fw-bold">Página {page + 1} de {totalPages}</span>
            <Button variant="secondary" onClick={() => setPage(page + 1)} disabled={page >= totalPages - 1}>
              Siguiente <FaArrowRight />
            </Button>
          </div>
        </>
      )}

      <div className="col-md-6 col-lg-8 mx-auto">
        {formMode === 'create' && (
          <PerformanceForm onclose={handleFormClose} onSuccess={refetch} eventId={eventId} registrationId={registrationId} schoolId={schoolId} />
        )}
        {formMode === 'edit' && selectedPerformance && (
  <PerformanceEdit
    onclose={handleFormClose}
    onSuccess={refetch}
    eventId={eventId}
    performance={selectedPerformance} // ✅ 
    registrationId={registrationId}
    schoolId={schoolId} // ✅ Se pasa schoolId si existe en performance
  />
)}
      </div>

      <ConfirmModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        
      />
{/* Botón flotante */}
      <FloatingButton
        onClick={handleNewPerformance}
        icon={<FaPlus size={24} />}
        title="Agregar nueva obra"
        position="add"
      />
    <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
      
    </Container>
  );
};

export default ManagementPerformances;

